module.exports = __webpack_public_path__ + "static/media/coppied.6c78381b.svg";